module.exports = __webpack_public_path__ + "media/images/hexagon-02046a3f983cfcc418e9f3418b057a11.jpg";